/* eslint-disable import/prefer-default-export */
export enum BranchSelectionModalMode {
    SelectAndEditOrg = 'SelectAndEditOrg',
    RFQSelectOrg = 'RFQSelectOrg',
}
